import React from 'react';
import type { PageDetailOut } from '../types/catalog';
import { isContentEmpty } from '../utils/normalizePageDetail';
import { getTemplateComponent } from './registry';
import { UnknownTemplatePanel } from './UnknownTemplatePanel';

interface TemplateRendererProps {
  page: PageDetailOut | null;
  onComplete?: () => void;
}

export const TemplateRenderer: React.FC<TemplateRendererProps> = ({ page, onComplete }) => {
  if (!page) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500 dark:text-gray-400 p-6">
        Select a page to view
      </div>
    );
  }

  const templateId: string | undefined =
    (page.template_id as string | undefined) ?? (page.page_json_v1?.template_id as string | undefined);
  const Component = getTemplateComponent(templateId);

  if (!Component) {
    return <UnknownTemplatePanel templateId={templateId ?? undefined} page={page} />;
  }

  if (isContentEmpty(page)) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500 dark:text-gray-400 p-6">
        <div className="text-center">
          <p>Template: {templateId ?? 'unknown'}</p>
          <p className="text-sm mt-1">No content (sections and blocks empty)</p>
        </div>
      </div>
    );
  }

  return <Component page={page} onComplete={onComplete} />;
};
